var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "themeArea"
  }, [!_vm.dataLoaded ? _c('div', {
    staticClass: "themeScreenLoading"
  }, [_vm._m(0)]) : _vm._e(), !_vm.hasScheduledActivity && _vm.dataLoaded ? _c('div', {
    staticClass: "themeScreen",
    style: {
      backgroundColor: _vm.theme.color
    },
    attrs: {
      "id": "themeScreen"
    }
  }, [_c('h1', {
    staticClass: "themeTitle"
  }, [_vm._v(_vm._s(_vm.theme.name))]), !_vm.isSpeedyKid ? _c('div', {
    staticClass: "theme-progress-area",
    attrs: {
      "aria-label": "activities completed",
      "role": "progressbar",
      "aria-valuemax": _vm.curriculumPosition.progress.theme.total,
      "aria-valuenow": _vm.curriculumPosition.progress.theme.position
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "theme-progress-container"
  }, _vm._l(_vm.progressDivisions, function (item) {
    return _c('divider', {
      key: item.key,
      attrs: {
        "bordercolor": _vm.theme.color,
        "awardname": _vm.theme.awardName,
        "progress-bg": item.progressBg,
        "progress": item.progress
      }
    });
  }), 1)]) : _c('div', {
    staticClass: "theme-progress-area"
  }, [_c('div', {
    staticClass: "speedyGoodJob"
  }, [_c('p', [_vm._v("You're doing a great job, " + _vm._s(_vm.username) + "!")])])]), _c('button', {
    staticClass: "theme-button-continue",
    attrs: {
      "aria-label": "Continue",
      "tabindex": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.button)
    },
    on: {
      "click": _vm.goToActivity
    }
  })]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "themeIconWrapper"
  }, [_c('img', {
    staticClass: "themeIcon",
    attrs: {
      "id": "iconOutline"
    }
  }), _c('img', {
    staticClass: "themeIcon",
    attrs: {
      "id": "themeIcon"
    }
  })]);
}]

export { render, staticRenderFns }